<script lang="ts">
	import { AlertV2, SidepanelContent } from '@Shelly/shelly-design-system';
	import { format } from 'svelte-i18n';
	import ControlGroupColor from 'src/components/Controls/Group/ControlGroupColor.svelte';
	import ControlGroupColorTemp from 'src/components/Controls/Group/ControlGroupColorTemp.svelte';
	import ControlGroupMode from 'src/components/Controls/Group/ControlGroupMode.svelte';

	export let color_mode_lights = [];
	export let white_mode_lights = [];
	export let change_mode_lights = [];
	export let hasRGBW2 = false;
	export let isGroupModeSwitchEligible = false;
	export let modeChangeBlockingType: string | null = null;
	export let active_mode = 'color';
</script>

<SidepanelContent>
	{#if change_mode_lights.length > 0}
		{#if isGroupModeSwitchEligible}
			<ControlGroupMode {change_mode_lights} {hasRGBW2} />
		{:else if modeChangeBlockingType}
			<AlertV2
				class="mb-m"
				heading={$format('group_mode_unsupported_desc', {
					default:
						"Mode change isn't supported from groups when a {blockingType} device is included.",
					values: { blockingType: modeChangeBlockingType },
				})}
			/>
		{/if}
	{/if}
	{#key active_mode}
		{#if color_mode_lights.length > 0}
			<ControlGroupColor {color_mode_lights} />
		{/if}
		{#if white_mode_lights.length > 0}
			<ControlGroupColorTemp {white_mode_lights} />
		{/if}
	{/key}
</SidepanelContent>
